import React from 'react';
import '../../styles/design-system.css';

/**
 * Button Component
 * Professional button matching iLovePDF design
 * 
 * @param {Object} props
 * @param {string} props.variant - 'primary' | 'secondary' | 'ghost' | 'success' | 'danger'
 * @param {string} props.size - 'sm' | 'md' | 'lg' | 'xl'
 * @param {boolean} props.fullWidth - Make button full width
 * @param {boolean} props.icon - Icon-only button
 * @param {boolean} props.loading - Show loading state
 * @param {boolean} props.disabled - Disable button
 * @param {React.ReactNode} props.children - Button content
 * @param {Function} props.onClick - Click handler
 */
const Button = ({
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    icon = false,
    loading = false,
    disabled = false,
    children,
    onClick,
    className = '',
    ...props
}) => {
    const baseClass = 'btn';
    const variantClass = `btn-${variant}`;
    const sizeClass = size !== 'md' ? `btn-${size}` : '';
    const fullWidthClass = fullWidth ? 'btn-full' : '';
    const iconClass = icon ? 'btn-icon' : '';

    const classes = [
        baseClass,
        variantClass,
        sizeClass,
        fullWidthClass,
        iconClass,
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            className={classes}
            onClick={onClick}
            disabled={disabled || loading}
            {...props}
        >
            {loading && (
                <span className="loading-spinner" />
            )}
            {children}
        </button>
    );
};

export default Button;
